// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("@/assets/svg/payment_succeed.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! @import */
/*! tailwindcss v3.4.1 | MIT License | https://tailwindcss.com */
/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/
*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #cfcfd3; /* 2 */
}
::before,
::after {
  --tw-content: '';
}
/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/
html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  tab-size: 4; /* 3 */
  font-family: Inter, sans-serif; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}
/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/
body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}
/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/
hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}
/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/
abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}
/*
Remove the default font size and weight for headings.
*/
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}
/*
Reset links to optimize for opt-in styling instead of opt-out.
*/
a {
  color: inherit;
  text-decoration: inherit;
}
/*
Add the correct font weight in Edge and Safari.
*/
b,
strong {
  font-weight: bolder;
}
/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/
code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}
/*
Add the correct font size in all browsers.
*/
small {
  font-size: 80%;
}
/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}
sub {
  bottom: -0.25em;
}
sup {
  top: -0.5em;
}
/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/
table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}
/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/
button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}
/*
Remove the inheritance of text transform in Edge and Firefox.
*/
button,
select {
  text-transform: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/
button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}
/*
Use the modern Firefox focus style for all focusable elements.
*/
:-moz-focusring {
  outline: auto;
}
/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/
:-moz-ui-invalid {
  box-shadow: none;
}
/*
Add the correct vertical alignment in Chrome and Firefox.
*/
progress {
  vertical-align: baseline;
}
/*
Correct the cursor style of increment and decrement buttons in Safari.
*/
::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}
/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/
[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}
/*
Remove the inner padding in Chrome and Safari on macOS.
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/
::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}
/*
Add the correct display in Chrome and Safari.
*/
summary {
  display: list-item;
}
/*
Removes the default spacing and border for appropriate elements.
*/
blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}
fieldset {
  margin: 0;
  padding: 0;
}
legend {
  padding: 0;
}
ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}
/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}
/*
Prevent resizing textareas horizontally by default.
*/
textarea {
  resize: vertical;
}
/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/
input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; /* 1 */
  color: #b2b1b9; /* 2 */
}
input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #b2b1b9; /* 2 */
}
/*
Set the default cursor for buttons.
*/
button,
[role="button"] {
  cursor: pointer;
}
/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}
/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/
img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}
/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/
img,
video {
  max-width: 100%;
  height: auto;
}
/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}
:root {
  --color-transparent: transparent;
  --color-current: currentColor;
  --color-black: #000;
  --color-white: #fff;
  --color-primary: rgb(var(--color-primary) / <alpha-value>);
  --color-on-primary: rgb(var(--color-on-primary) / <alpha-value>);
  --color-primary-hover: rgb(var(--color-primary-hover) / <alpha-value>);
  --color-on-primary-hover: rgb(var(--color-on-primary-hover) / <alpha-value>);
  --color-primary-selected: rgb(var(--color-primary-selected) / <alpha-value>);
  --color-secondary: rgb(var(--color-secondary) / <alpha-value>);
  --color-on-secondary: rgb(var(--color-on-secondary) / <alpha-value>);
  --color-tertiary: rgb(var(--color-tertiary) / <alpha-value>);
  --color-on-tertiary: rgb(var(--color-on-tertiary) / <alpha-value>);
  --color-alert: rgb(var(--color-alert) / <alpha-value>);
  --color-surface-dark: rgb(var(--color-surface-dark) / <alpha-value>);
  --color-surface-light: rgb(var(--color-surface-light) / <alpha-value>);
  --color-off-white: rgb(var(--color-off-white) / <alpha-value>);
  --color-dark-text: rgb(var(--color-dark-text) / <alpha-value>);
  --color-semi-dark-text: rgb(var(--color-semi-dark-text) / <alpha-value>);
  --color-stroke: rgb(var(--color-stroke) / <alpha-value>);
  --color-gray-100: #fafafa;
  --color-gray-200: #ebebec;
  --color-gray-300: #cfcfd3;
  --color-gray-400: #b2b1b9;
  --color-gray-500: #8b8b97;
  --color-gray-600: #706f7e;
  --color-gray-700: #545465;
  --color-gray-800: #39384c;
  --color-gray-900: #1d1c33;
  --color-red-100: #FFE6E6;
  --color-red-200: #fed7d7;
  --color-red-300: #feb2b2;
  --color-red-400: #fc8181;
  --color-red-500: #f56565;
  --color-red-600: #e53e3e;
  --color-red-700: #c53030;
  --color-red-800: #9b2c2c;
  --color-red-900: #742a2a;
  --color-orange-100: #fffaf0;
  --color-orange-200: #feebc8;
  --color-orange-300: #fbd38d;
  --color-orange-400: #f6ad55;
  --color-orange-500: #ed8936;
  --color-orange-600: #dd6b20;
  --color-orange-700: #c05621;
  --color-orange-800: #9c4221;
  --color-orange-900: #7b341e;
  --color-yellow-100: #fffff0;
  --color-yellow-200: #fefcbf;
  --color-yellow-300: #faf089;
  --color-yellow-400: #f6e05e;
  --color-yellow-500: #ecc94b;
  --color-yellow-600: #d69e2e;
  --color-yellow-700: #b7791f;
  --color-yellow-800: #975a16;
  --color-yellow-900: #744210;
  --color-green-100: #E5FDDB;
  --color-green-200: #c6f6d5;
  --color-green-300: #9ae6b4;
  --color-green-400: #68d391;
  --color-green-500: #48bb78;
  --color-green-600: #38a169;
  --color-green-700: #2f855a;
  --color-green-800: #276749;
  --color-green-900: #22543d;
  --color-teal-100: #e6fffa;
  --color-teal-200: #b2f5ea;
  --color-teal-300: #81e6d9;
  --color-teal-400: #4fd1c5;
  --color-teal-500: #38b2ac;
  --color-teal-600: #319795;
  --color-teal-700: #2c7a7b;
  --color-teal-800: #285e61;
  --color-teal-900: #234e52;
  --color-blue-100: #ebf8ff;
  --color-blue-200: #bee3f8;
  --color-blue-300: #90cdf4;
  --color-blue-400: #63b3ed;
  --color-blue-500: #4299e1;
  --color-blue-600: #3182ce;
  --color-blue-700: #2b6cb0;
  --color-blue-800: #2c5282;
  --color-blue-900: #2a4365;
  --color-indigo-50: #f4f9ff;
  --color-indigo-100: #ebf4ff;
  --color-indigo-200: #c3dafe;
  --color-indigo-300: #a3bffa;
  --color-indigo-400: #7f9cf5;
  --color-indigo-500: #667eea;
  --color-indigo-600: #5a67d8;
  --color-indigo-700: #4c51bf;
  --color-indigo-800: #434190;
  --color-indigo-900: #3c366b;
  --color-purple-100: #faf5ff;
  --color-purple-200: #e9e6fc;
  --color-purple-300: #d6bcfa;
  --color-purple-400: #b794f4;
  --color-purple-500: #9f7aea;
  --color-purple-600: #805ad5;
  --color-purple-700: #6b46c1;
  --color-purple-800: #553c9a;
  --color-purple-900: #44337a;
  --color-pink-100: #fff5f7;
  --color-pink-200: #fed7e2;
  --color-pink-300: #fbb6ce;
  --color-pink-400: #f687b3;
  --color-pink-500: #ed64a6;
  --color-pink-600: #d53f8c;
  --color-pink-700: #b83280;
  --color-pink-800: #97266d;
  --color-pink-900: #702459;
    --color-primary: 91 71 194;
    --color-on-primary: 255 255 255;
    --color-primary-hover: 163 191 250;
    --color-on-primary-hover: 91 71 194;
    --color-primary-selected: 63 46 155;
    --color-secondary: 65 160 255;
    --color-on-secondary: 255 255 255;
    --color-tertiary: 55 79 226;
    --color-on-tertiary: 250 250 250;
    --color-alert: 241 68 110;
    --color-surface-dark: 250 249 255;
    --color-surface-light: 246 244 254;
    --color-off-white: 249 249 255;
    --color-dark-text: 28 25 85;
    --color-semi-dark-text: 45 40 73;
    --color-stroke: 220 216 238;
    --color-input: 51 51 51;
    --color-menu-background: 91 71 194;
    --color-menu-shadow: 91 71 194;
    --color-menu-border: 0 196 184;
    --color-menu-selected-border: 255 255 255;
    --color-menu-text: 255 255 255;
}
*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(66 153 225 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(66 153 225 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

html,
body {
  /*@apply h-full;*/
  /* @apply max-h-full; */
  font-family: Inter, sans-serif;
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity));
  font-size: 14px;
}
h1 {
  font-size: 64px;
  font-weight: 700;
  line-height: initial;
}
h2 {
  font-size: 48px;
  font-weight: 400;
  line-height: initial;
}
h3 {
  font-size: 30px;
  font-weight: 700;
  line-height: initial;
}
h4,
h5,
h6 {
  font-weight: 700;
  line-height: initial;
}
a {
  --tw-text-opacity: 1;
  color: rgb(49 130 206 / var(--tw-text-opacity));
  text-decoration-line: underline;
}

.text-gray-100 i {
  font-style: normal;
  color: black;
}

:not(svg) > g,
.text-green-100 i {
  font-style: normal;
  color: #40a215;
}
svg g {
  color: currentColor;
}

:not(svg) > r,
.text-red-100 i {
  font-style: normal;
  color: #c91e1e;
}

svg r {
  color: currentColor;
}

.container {
  width: 100%;
}

@media (min-width: 400px) {
  .container {
    max-width: 400px;
  }
}

@media (min-width: 576px) {
  .container {
    max-width: 576px;
  }
}

@media (min-width: 768px) {
  .container {
    max-width: 768px;
  }
}

@media (min-width: 996px) {
  .container {
    max-width: 996px;
  }
}

@media (min-width: 1200px) {
  .container {
    max-width: 1200px;
  }
}

@media (min-width: 1600px) {
  .container {
    max-width: 1600px;
  }
}

@media (min-width: 1900px) {
  .container {
    max-width: 1900px;
  }
}
.pointer-events-none {
  pointer-events: none;
}
.pointer-events-auto {
  pointer-events: auto;
}
.visible {
  visibility: visible;
}
.invisible {
  visibility: hidden;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.inset-0 {
  inset: 0;
}
.inset-y-0 {
  top: 0;
  bottom: 0;
}
.\\!bottom-0 {
  bottom: 0 !important;
}
.-bottom-20 {
  bottom: -80px;
}
.-bottom-30 {
  bottom: -120px;
}
.-right-1\\/2 {
  right: -50%;
}
.-right-20 {
  right: -80px;
}
.-right-3 {
  right: -12px;
}
.-top-3 {
  top: -12px;
}
.-top-\\[6px\\] {
  top: -6px;
}
.bottom-0 {
  bottom: 0;
}
.bottom-1 {
  bottom: 4px;
}
.bottom-2 {
  bottom: 8px;
}
.bottom-5 {
  bottom: 20px;
}
.left-0 {
  left: 0;
}
.left-2 {
  left: 8px;
}
.left-3 {
  left: 12px;
}
.left-top-bar {
  left: 104px;
}
.left-top-bar--opened {
  left: 300px;
}
.right-0 {
  right: 0;
}
.right-10 {
  right: 40px;
}
.right-17 {
  right: 68px;
}
.right-2 {
  right: 8px;
}
.right-3 {
  right: 12px;
}
.right-4 {
  right: 16px;
}
.right-5 {
  right: 20px;
}
.right-6 {
  right: 24px;
}
.right-8 {
  right: 32px;
}
.top-0 {
  top: 0;
}
.top-1 {
  top: 4px;
}
.top-10 {
  top: 40px;
}
.top-12 {
  top: 48px;
}
.top-14 {
  top: 56px;
}
.top-16 {
  top: 64px;
}
.top-2 {
  top: 8px;
}
.top-3 {
  top: 12px;
}
.top-5 {
  top: 20px;
}
.top-6 {
  top: 24px;
}
.top-7 {
  top: 28px;
}
.z-0 {
  z-index: 0;
}
.z-1 {
  z-index: 1;
}
.z-10 {
  z-index: 10;
}
.z-2 {
  z-index: 2;
}
.z-30 {
  z-index: 30;
}
.z-40 {
  z-index: 40;
}
.z-\\[10000\\] {
  z-index: 10000;
}
.order-1 {
  order: 1;
}
.order-4 {
  order: 4;
}
.col-span-2 {
  grid-column: span 2 / span 2;
}
.col-span-3 {
  grid-column: span 3 / span 3;
}
.col-span-4 {
  grid-column: span 4 / span 4;
}
.col-start-1 {
  grid-column-start: 1;
}
.col-end-1 {
  grid-column-end: 1;
}
.col-end-2 {
  grid-column-end: 2;
}
.row-start-1 {
  grid-row-start: 1;
}
.row-end-1 {
  grid-row-end: 1;
}
.row-end-2 {
  grid-row-end: 2;
}
.m-0 {
  margin: 0;
}
.m-0\\.5 {
  margin: 2px;
}
.m-1 {
  margin: 4px;
}
.m-4 {
  margin: 16px;
}
.mx-1 {
  margin-left: 4px;
  margin-right: 4px;
}
.mx-10 {
  margin-left: 40px;
  margin-right: 40px;
}
.mx-2 {
  margin-left: 8px;
  margin-right: 8px;
}
.mx-3 {
  margin-left: 12px;
  margin-right: 12px;
}
.mx-4 {
  margin-left: 16px;
  margin-right: 16px;
}
.mx-5 {
  margin-left: 20px;
  margin-right: 20px;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-1 {
  margin-top: 4px;
  margin-bottom: 4px;
}
.my-10 {
  margin-top: 40px;
  margin-bottom: 40px;
}
.my-2 {
  margin-top: 8px;
  margin-bottom: 8px;
}
.my-3 {
  margin-top: 12px;
  margin-bottom: 12px;
}
.my-4 {
  margin-top: 16px;
  margin-bottom: 16px;
}
.my-5 {
  margin-top: 20px;
  margin-bottom: 20px;
}
.my-6 {
  margin-top: 24px;
  margin-bottom: 24px;
}
.my-8 {
  margin-top: 32px;
  margin-bottom: 32px;
}
.my-auto {
  margin-top: auto;
  margin-bottom: auto;
}
.\\!mb-0 {
  margin-bottom: 0 !important;
}
.-mb-1 {
  margin-bottom: -4px;
}
.-mb-2 {
  margin-bottom: -8px;
}
.-mb-5 {
  margin-bottom: -20px;
}
.-ml-3 {
  margin-left: -12px;
}
.-ml-4 {
  margin-left: -16px;
}
.-mr-2 {
  margin-right: -8px;
}
.-mr-\\[4px\\] {
  margin-right: -4px;
}
.-mt-1 {
  margin-top: -4px;
}
.-mt-2 {
  margin-top: -8px;
}
.-mt-3 {
  margin-top: -12px;
}
.mb-0 {
  margin-bottom: 0;
}
.mb-0\\.5 {
  margin-bottom: 2px;
}
.mb-1 {
  margin-bottom: 4px;
}
.mb-1\\.5 {
  margin-bottom: 6px;
}
.mb-10 {
  margin-bottom: 40px;
}
.mb-12 {
  margin-bottom: 48px;
}
.mb-2 {
  margin-bottom: 8px;
}
.mb-3 {
  margin-bottom: 12px;
}
.mb-4 {
  margin-bottom: 16px;
}
.mb-5 {
  margin-bottom: 20px;
}
.mb-6 {
  margin-bottom: 24px;
}
.mb-7 {
  margin-bottom: 28px;
}
.mb-\\[3px\\] {
  margin-bottom: 3px;
}
.ml-1 {
  margin-left: 4px;
}
.ml-10 {
  margin-left: 40px;
}
.ml-2 {
  margin-left: 8px;
}
.ml-3 {
  margin-left: 12px;
}
.ml-4 {
  margin-left: 16px;
}
.ml-5 {
  margin-left: 20px;
}
.ml-6 {
  margin-left: 24px;
}
.ml-8 {
  margin-left: 32px;
}
.ml-auto {
  margin-left: auto;
}
.mr-0 {
  margin-right: 0;
}
.mr-1 {
  margin-right: 4px;
}
.mr-2 {
  margin-right: 8px;
}
.mr-3 {
  margin-right: 12px;
}
.mr-4 {
  margin-right: 16px;
}
.mr-5 {
  margin-right: 20px;
}
.mr-auto {
  margin-right: auto;
}
.mt-0 {
  margin-top: 0;
}
.mt-0\\.5 {
  margin-top: 2px;
}
.mt-1 {
  margin-top: 4px;
}
.mt-10 {
  margin-top: 40px;
}
.mt-12 {
  margin-top: 48px;
}
.mt-15 {
  margin-top: 60px;
}
.mt-2 {
  margin-top: 8px;
}
.mt-20 {
  margin-top: 80px;
}
.mt-3 {
  margin-top: 12px;
}
.mt-4 {
  margin-top: 16px;
}
.mt-5 {
  margin-top: 20px;
}
.mt-6 {
  margin-top: 24px;
}
.mt-7 {
  margin-top: 28px;
}
.mt-8 {
  margin-top: 32px;
}
.mt-\\[2px\\] {
  margin-top: 2px;
}
.mt-\\[7px\\] {
  margin-top: 7px;
}
.mt-auto {
  margin-top: auto;
}
.mt-px {
  margin-top: 1px;
}
.box-border {
  box-sizing: border-box;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.\\!table {
  display: table !important;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.\\!h-10 {
  height: 40px !important;
}
.\\!h-20 {
  height: 80px !important;
}
.\\!h-7 {
  height: 28px !important;
}
.h-0 {
  height: 0;
}
.h-1 {
  height: 4px;
}
.h-10 {
  height: 40px;
}
.h-11 {
  height: 44px;
}
.h-12 {
  height: 48px;
}
.h-14 {
  height: 56px;
}
.h-16 {
  height: 64px;
}
.h-18 {
  height: 72px;
}
.h-2 {
  height: 8px;
}
.h-20 {
  height: 80px;
}
.h-220 {
  height: 220px;
}
.h-25 {
  height: 100px;
}
.h-250 {
  height: 250px;
}
.h-3 {
  height: 12px;
}
.h-300 {
  height: 300px;
}
.h-320 {
  height: 320px;
}
.h-35 {
  height: 140px;
}
.h-38 {
  height: 152px;
}
.h-4 {
  height: 16px;
}
.h-40 {
  height: 160px;
}
.h-400 {
  height: 400px;
}
.h-450 {
  height: 450px;
}
.h-5 {
  height: 20px;
}
.h-6 {
  height: 24px;
}
.h-600 {
  height: 600px;
}
.h-7 {
  height: 28px;
}
.h-8 {
  height: 32px;
}
.h-9 {
  height: 36px;
}
.h-\\[15px\\] {
  height: 15px;
}
.h-\\[18px\\] {
  height: 18px;
}
.h-\\[200px\\] {
  height: 200px;
}
.h-\\[21px\\] {
  height: 21px;
}
.h-\\[26px\\] {
  height: 26px;
}
.h-\\[298px\\] {
  height: 298px;
}
.h-\\[70\\%\\] {
  height: 70%;
}
.h-\\[80px\\] {
  height: 80px;
}
.h-full {
  height: 100%;
}
.h-px {
  height: 1px;
}
.h-screen {
  height: 100vh;
}
.max-h-0 {
  max-height: 0px;
}
.max-h-150 {
  max-height: 150px;
}
.max-h-200 {
  max-height: 200px;
}
.max-h-300 {
  max-height: 300px;
}
.max-h-400 {
  max-height: 400px;
}
.max-h-44 {
  max-height: 176px;
}
.max-h-470 {
  max-height: 470px;
}
.max-h-500 {
  max-height: 500px;
}
.max-h-56 {
  max-height: 224px;
}
.max-h-58 {
  max-height: 232px;
}
.max-h-600 {
  max-height: 600px;
}
.max-h-\\[400px\\] {
  max-height: 400px;
}
.max-h-\\[50\\%\\] {
  max-height: 50%;
}
.max-h-\\[50px\\] {
  max-height: 50px;
}
.max-h-full {
  max-height: 100%;
}
.max-h-screen {
  max-height: 100vh;
}
.\\!min-h-24 {
  min-height: 96px !important;
}
.min-h-0 {
  min-height: 0;
}
.min-h-10 {
  min-height: 40px;
}
.min-h-100 {
  min-height: 100px;
}
.min-h-13 {
  min-height: 52px;
}
.min-h-14 {
  min-height: 56px;
}
.min-h-150 {
  min-height: 150px;
}
.min-h-16 {
  min-height: 64px;
}
.min-h-21 {
  min-height: 84px;
}
.min-h-300 {
  min-height: 300px;
}
.min-h-40 {
  min-height: 160px;
}
.min-h-400 {
  min-height: 400px;
}
.min-h-5 {
  min-height: 20px;
}
.min-h-500 {
  min-height: 500px;
}
.min-h-6 {
  min-height: 24px;
}
.min-h-8 {
  min-height: 32px;
}
.min-h-9 {
  min-height: 36px;
}
.min-h-\\[250px\\] {
  min-height: 250px;
}
.min-h-\\[450px\\] {
  min-height: 450px;
}
.min-h-full {
  min-height: 100%;
}
.\\!w-600 {
  width: 600px !important;
}
.\\!w-7 {
  width: 28px !important;
}
.\\!w-\\[95vw\\] {
  width: 95vw !important;
}
.w-0 {
  width: 0;
}
.w-1\\/2 {
  width: 50%;
}
.w-1\\/3 {
  width: 33.333333%;
}
.w-10 {
  width: 40px;
}
.w-100 {
  width: 100px;
}
.w-11 {
  width: 44px;
}
.w-12 {
  width: 48px;
}
.w-14 {
  width: 56px;
}
.w-15 {
  width: 60px;
}
.w-150 {
  width: 150px;
}
.w-16 {
  width: 64px;
}
.w-160 {
  width: 160px;
}
.w-18 {
  width: 72px;
}
.w-180 {
  width: 180px;
}
.w-2 {
  width: 8px;
}
.w-20 {
  width: 80px;
}
.w-200 {
  width: 200px;
}
.w-230 {
  width: 230px;
}
.w-25 {
  width: 100px;
}
.w-250 {
  width: 250px;
}
.w-26 {
  width: 104px;
}
.w-3 {
  width: 12px;
}
.w-30 {
  width: 120px;
}
.w-300 {
  width: 300px;
}
.w-335 {
  width: 335px;
}
.w-36 {
  width: 144px;
}
.w-4 {
  width: 16px;
}
.w-40 {
  width: 160px;
}
.w-450 {
  width: 450px;
}
.w-5 {
  width: 20px;
}
.w-50 {
  width: 200px;
}
.w-6 {
  width: 24px;
}
.w-600 {
  width: 600px;
}
.w-7 {
  width: 28px;
}
.w-8 {
  width: 32px;
}
.w-9 {
  width: 36px;
}
.w-900 {
  width: 900px;
}
.w-\\[140px\\] {
  width: 140px;
}
.w-\\[150px\\] {
  width: 150px;
}
.w-\\[15px\\] {
  width: 15px;
}
.w-\\[180px\\] {
  width: 180px;
}
.w-\\[18px\\] {
  width: 18px;
}
.w-\\[21px\\] {
  width: 21px;
}
.w-\\[26px\\] {
  width: 26px;
}
.w-\\[40\\%\\] {
  width: 40%;
}
.w-\\[70\\%\\] {
  width: 70%;
}
.w-\\[80px\\] {
  width: 80px;
}
.w-auto {
  width: auto;
}
.w-full {
  width: 100%;
}
.w-screen {
  width: 100vw;
}
.w-sidebar {
  width: 104px;
}
.w-sidebar--opened {
  width: 300px;
}
.min-w-0 {
  min-width: 0;
}
.min-w-100 {
  min-width: 100px;
}
.min-w-150 {
  min-width: 150px;
}
.min-w-200 {
  min-width: 200px;
}
.min-w-300 {
  min-width: 300px;
}
.min-w-320 {
  min-width: 320px;
}
.min-w-\\[140px\\] {
  min-width: 140px;
}
.min-w-full {
  min-width: 100%;
}
.max-w-100 {
  max-width: 100px;
}
.max-w-1000 {
  max-width: 1000px;
}
.max-w-200 {
  max-width: 200px;
}
.max-w-300 {
  max-width: 300px;
}
.max-w-350 {
  max-width: 350px;
}
.max-w-400 {
  max-width: 400px;
}
.max-w-50 {
  max-width: 50px;
}
.max-w-500 {
  max-width: 500px;
}
.max-w-600 {
  max-width: 600px;
}
.max-w-700 {
  max-width: 700px;
}
.max-w-800 {
  max-width: 800px;
}
.max-w-900 {
  max-width: 900px;
}
.max-w-\\[1800px\\] {
  max-width: 1800px;
}
.max-w-\\[200px\\] {
  max-width: 200px;
}
.max-w-\\[50px\\] {
  max-width: 50px;
}
.max-w-full {
  max-width: 100%;
}
.max-w-screen-xxl {
  max-width: 1600px;
}
.flex-1 {
  flex: 1 1 0%;
}
.flex-initial {
  flex: 0 1 auto;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.shrink-0 {
  flex-shrink: 0;
}
.flex-grow {
  flex-grow: 1;
}
.flex-grow-0 {
  flex-grow: 0;
}
.flex-grow-\\[1\\] {
  flex-grow: 1;
}
.flex-grow-\\[999\\] {
  flex-grow: 999;
}
.border-separate {
  border-collapse: separate;
}
.border-spacing-0 {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  border-spacing: var(--tw-border-spacing-x) var(--tw-border-spacing-y);
}
.border-spacing-y-3 {
  --tw-border-spacing-y: 12px;
  border-spacing: var(--tw-border-spacing-x) var(--tw-border-spacing-y);
}
.origin-0 {
  transform-origin: 0%;
}
.-translate-y-6 {
  --tw-translate-y: -24px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-1 {
  --tw-translate-x: 4px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-5 {
  --tw-translate-x: 20px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-full {
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-90 {
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90 {
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-75 {
  --tw-scale-x: .75;
  --tw-scale-y: .75;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.cursor-default {
  cursor: default;
}
.cursor-grab {
  cursor: grab;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
}
.select-none {
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}
.resize {
  resize: both;
}
.list-decimal {
  list-style-type: decimal;
}
.list-disc {
  list-style-type: disc;
}
.appearance-none {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
}
.auto-cols-fr {
  grid-auto-columns: minmax(0, 1fr);
}
.grid-flow-col {
  grid-auto-flow: column;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-12 {
  grid-template-columns: repeat(12, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-collection-mobile {
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
}
.flex-row {
  flex-direction: row;
}
.flex-row-reverse {
  flex-direction: row-reverse;
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.items-baseline {
  align-items: baseline;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-items-center {
  justify-items: center;
}
.gap-0 {
  gap: 0;
}
.gap-0\\.5 {
  gap: 2px;
}
.gap-1 {
  gap: 4px;
}
.gap-10 {
  gap: 40px;
}
.gap-2 {
  gap: 8px;
}
.gap-3 {
  gap: 12px;
}
.gap-4 {
  gap: 16px;
}
.gap-8 {
  gap: 32px;
}
.gap-x-1 {
  -moz-column-gap: 4px;
       column-gap: 4px;
}
.gap-x-2 {
  -moz-column-gap: 8px;
       column-gap: 8px;
}
.gap-x-3 {
  -moz-column-gap: 12px;
       column-gap: 12px;
}
.gap-x-4 {
  -moz-column-gap: 16px;
       column-gap: 16px;
}
.gap-x-5 {
  -moz-column-gap: 20px;
       column-gap: 20px;
}
.gap-x-6 {
  -moz-column-gap: 24px;
       column-gap: 24px;
}
.gap-y-1 {
  row-gap: 4px;
}
.gap-y-3 {
  row-gap: 12px;
}
.gap-y-4 {
  row-gap: 16px;
}
.gap-y-5 {
  row-gap: 20px;
}
.space-x-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(12px * var(--tw-space-x-reverse));
  margin-left: calc(12px * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(8px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(8px * var(--tw-space-y-reverse));
}
.divide-y > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-gray-300 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(207 207 211 / var(--tw-divide-opacity));
}
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.\\!overflow-visible {
  overflow: visible !important;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
.overflow-y-scroll {
  overflow-y: scroll;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.overflow-ellipsis {
  text-overflow: ellipsis;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.whitespace-pre {
  white-space: pre;
}
.whitespace-pre-wrap {
  white-space: pre-wrap;
}
.break-words {
  overflow-wrap: break-word;
}
.break-all {
  word-break: break-all;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-10 {
  border-radius: 10px;
}
.rounded-12 {
  border-radius: 12px;
}
.rounded-14 {
  border-radius: 14px;
}
.rounded-2 {
  border-radius: 2px;
}
.rounded-20 {
  border-radius: 20px;
}
.rounded-4 {
  border-radius: 4px;
}
.rounded-6 {
  border-radius: 6px;
}
.rounded-8 {
  border-radius: 8px;
}
.rounded-\\[16px\\] {
  border-radius: 16px;
}
.rounded-\\[30px\\] {
  border-radius: 30px;
}
.rounded-\\[8px\\] {
  border-radius: 8px;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-b-10 {
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
}
.rounded-b-2xl {
  border-bottom-right-radius: 1rem;
  border-bottom-left-radius: 1rem;
}
.rounded-b-lg {
  border-bottom-right-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.rounded-l-10 {
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}
.rounded-l-6 {
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}
.rounded-r-full {
  border-top-right-radius: 9999px;
  border-bottom-right-radius: 9999px;
}
.rounded-t-10 {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.rounded-t-12 {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
.rounded-t-20 {
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}
.rounded-t-4 {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.rounded-t-6 {
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}
.rounded-t-md {
  border-top-left-radius: 0.375rem;
  border-top-right-radius: 0.375rem;
}
.rounded-bl-20 {
  border-bottom-left-radius: 20px;
}
.rounded-bl-full {
  border-bottom-left-radius: 9999px;
}
.rounded-br-full {
  border-bottom-right-radius: 9999px;
}
.rounded-br-none {
  border-bottom-right-radius: 0;
}
.rounded-tl-20 {
  border-top-left-radius: 20px;
}
.rounded-tl-full {
  border-top-left-radius: 9999px;
}
.rounded-tr-20 {
  border-top-right-radius: 20px;
}
.rounded-tr-full {
  border-top-right-radius: 9999px;
}
.border {
  border-width: 1px;
}
.border-0 {
  border-width: 0px;
}
.border-2 {
  border-width: 2px;
}
.border-\\[1px\\] {
  border-width: 1px;
}
.border-x {
  border-left-width: 1px;
  border-right-width: 1px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-0 {
  border-bottom-width: 0px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-b-4 {
  border-bottom-width: 4px;
}
.border-b-\\[8px\\] {
  border-bottom-width: 8px;
}
.border-l {
  border-left-width: 1px;
}
.border-l-0 {
  border-left-width: 0px;
}
.border-l-4 {
  border-left-width: 4px;
}
.border-l-\\[6px\\] {
  border-left-width: 6px;
}
.border-r {
  border-right-width: 1px;
}
.border-r-0 {
  border-right-width: 0px;
}
.border-r-\\[6px\\] {
  border-right-width: 6px;
}
.border-t {
  border-top-width: 1px;
}
.border-solid {
  border-style: solid;
}
.border-dashed {
  border-style: dashed;
}
.border-dotted {
  border-style: dotted;
}
.border-none {
  border-style: none;
}
.\\!border-alert {
  --tw-border-opacity: 1 !important;
  border-color: rgb(var(--color-alert) / var(--tw-border-opacity)) !important;
}
.border-alert {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-alert) / var(--tw-border-opacity));
}
.border-blue-300 {
  --tw-border-opacity: 1;
  border-color: rgb(144 205 244 / var(--tw-border-opacity));
}
.border-gray-100 {
  --tw-border-opacity: 1;
  border-color: rgb(250 250 250 / var(--tw-border-opacity));
}
.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(235 235 236 / var(--tw-border-opacity));
}
.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(207 207 211 / var(--tw-border-opacity));
}
.border-gray-400 {
  --tw-border-opacity: 1;
  border-color: rgb(178 177 185 / var(--tw-border-opacity));
}
.border-green-500 {
  --tw-border-opacity: 1;
  border-color: rgb(72 187 120 / var(--tw-border-opacity));
}
.border-indigo-500 {
  --tw-border-opacity: 1;
  border-color: rgb(102 126 234 / var(--tw-border-opacity));
}
.border-primary {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));
}
.border-primary\\/30 {
  border-color: rgb(var(--color-primary) / 0.30);
}
.border-purple-200 {
  --tw-border-opacity: 1;
  border-color: rgb(233 230 252 / var(--tw-border-opacity));
}
.border-red-500 {
  --tw-border-opacity: 1;
  border-color: rgb(245 101 101 / var(--tw-border-opacity));
}
.border-secondary {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-secondary) / var(--tw-border-opacity));
}
.border-secondary\\/30 {
  border-color: rgb(var(--color-secondary) / 0.30);
}
.border-stroke {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-stroke) / var(--tw-border-opacity));
}
.border-stroke\\/50 {
  border-color: rgb(var(--color-stroke) / 0.5);
}
.border-transparent {
  border-color: transparent;
}
.border-b-surface-dark {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(var(--color-surface-dark) / var(--tw-border-opacity));
}
.border-l-transparent {
  border-left-color: transparent;
}
.border-r-transparent {
  border-right-color: transparent;
}
.border-opacity-10 {
  --tw-border-opacity: 0.1;
}
.border-opacity-20 {
  --tw-border-opacity: 0.2;
}
.border-opacity-40 {
  --tw-border-opacity: 0.4;
}
.border-opacity-50 {
  --tw-border-opacity: 0.5;
}
.border-opacity-70 {
  --tw-border-opacity: 0.7;
}
.\\!bg-primary {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity)) !important;
}
.bg-\\[\\#BC5CDA35\\] {
  background-color: #BC5CDA35;
}
.bg-\\[\\#F0EDFF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(240 237 255 / var(--tw-bg-opacity));
}
.bg-\\[\\#F1F1F1\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(241 241 241 / var(--tw-bg-opacity));
}
.bg-\\[\\#fcfcff\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(252 252 255 / var(--tw-bg-opacity));
}
.bg-\\[rgb\\(var\\(--color-menu-background\\)\\)\\] {
  background-color: rgb(var(--color-menu-background));
}
.bg-\\[rgb\\(var\\(--color-menu-selected-border\\)\\)\\] {
  background-color: rgb(var(--color-menu-selected-border));
}
.bg-alert {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-alert) / var(--tw-bg-opacity));
}
.bg-alert\\/10 {
  background-color: rgb(var(--color-alert) / 0.1);
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}
.bg-blue-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(235 248 255 / var(--tw-bg-opacity));
}
.bg-blue-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(190 227 248 / var(--tw-bg-opacity));
}
.bg-blue-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(144 205 244 / var(--tw-bg-opacity));
}
.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity));
}
.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(235 235 236 / var(--tw-bg-opacity));
}
.bg-gray-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(207 207 211 / var(--tw-bg-opacity));
}
.bg-gray-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(178 177 185 / var(--tw-bg-opacity));
}
.bg-gray-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(139 139 151 / var(--tw-bg-opacity));
}
.bg-green-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(198 246 213 / var(--tw-bg-opacity));
}
.bg-green-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(154 230 180 / var(--tw-bg-opacity));
}
.bg-green-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(72 187 120 / var(--tw-bg-opacity));
}
.bg-green-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(56 161 105 / var(--tw-bg-opacity));
}
.bg-indigo-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(235 244 255 / var(--tw-bg-opacity));
}
.bg-indigo-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(195 218 254 / var(--tw-bg-opacity));
}
.bg-indigo-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(102 126 234 / var(--tw-bg-opacity));
}
.bg-indigo-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(90 103 216 / var(--tw-bg-opacity));
}
.bg-indigo-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(76 81 191 / var(--tw-bg-opacity));
}
.bg-off-white {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-off-white) / var(--tw-bg-opacity));
}
.bg-on-primary {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-on-primary) / var(--tw-bg-opacity));
}
.bg-on-tertiary {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-on-tertiary) / var(--tw-bg-opacity));
}
.bg-orange-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(251 211 141 / var(--tw-bg-opacity));
}
.bg-pink-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 245 247 / var(--tw-bg-opacity));
}
.bg-pink-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 215 226 / var(--tw-bg-opacity));
}
.bg-primary {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));
}
.bg-primary-hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-primary-hover) / var(--tw-bg-opacity));
}
.bg-primary-selected {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-primary-selected) / var(--tw-bg-opacity));
}
.bg-primary\\/\\[0\\.08\\] {
  background-color: rgb(var(--color-primary) / 0.08);
}
.bg-purple-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(250 245 255 / var(--tw-bg-opacity));
}
.bg-purple-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(233 230 252 / var(--tw-bg-opacity));
}
.bg-purple-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(214 188 250 / var(--tw-bg-opacity));
}
.bg-red-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 215 215 / var(--tw-bg-opacity));
}
.bg-red-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 178 178 / var(--tw-bg-opacity));
}
.bg-red-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(245 101 101 / var(--tw-bg-opacity));
}
.bg-secondary {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-secondary) / var(--tw-bg-opacity));
}
.bg-secondary\\/10 {
  background-color: rgb(var(--color-secondary) / 0.1);
}
.bg-semi-dark-text {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-semi-dark-text) / var(--tw-bg-opacity));
}
.bg-stroke {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-stroke) / var(--tw-bg-opacity));
}
.bg-surface-dark {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-surface-dark) / var(--tw-bg-opacity));
}
.bg-surface-light {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-surface-light) / var(--tw-bg-opacity));
}
.bg-tertiary {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-tertiary) / var(--tw-bg-opacity));
}
.bg-transparent {
  background-color: transparent;
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-opacity-10 {
  --tw-bg-opacity: 0.1;
}
.bg-opacity-20 {
  --tw-bg-opacity: 0.2;
}
.bg-opacity-3 {
  --tw-bg-opacity: 0.03;
}
.bg-opacity-30 {
  --tw-bg-opacity: 0.30;
}
.bg-none {
  background-image: none;
}
.bg-payment-succeed {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.fill-current {
  fill: currentColor;
}
.object-cover {
  object-fit: cover;
}
.\\!p-1 {
  padding: 4px !important;
}
.p-0 {
  padding: 0;
}
.p-0\\.5 {
  padding: 2px;
}
.p-1 {
  padding: 4px;
}
.p-2 {
  padding: 8px;
}
.p-3 {
  padding: 12px;
}
.p-4 {
  padding: 16px;
}
.p-5 {
  padding: 20px;
}
.p-6 {
  padding: 24px;
}
.p-8 {
  padding: 32px;
}
.\\!px-3 {
  padding-left: 12px !important;
  padding-right: 12px !important;
}
.\\!px-8 {
  padding-left: 32px !important;
  padding-right: 32px !important;
}
.px-0 {
  padding-left: 0;
  padding-right: 0;
}
.px-0\\.5 {
  padding-left: 2px;
  padding-right: 2px;
}
.px-1 {
  padding-left: 4px;
  padding-right: 4px;
}
.px-1\\.5 {
  padding-left: 6px;
  padding-right: 6px;
}
.px-10 {
  padding-left: 40px;
  padding-right: 40px;
}
.px-12 {
  padding-left: 48px;
  padding-right: 48px;
}
.px-2 {
  padding-left: 8px;
  padding-right: 8px;
}
.px-20 {
  padding-left: 80px;
  padding-right: 80px;
}
.px-3 {
  padding-left: 12px;
  padding-right: 12px;
}
.px-4 {
  padding-left: 16px;
  padding-right: 16px;
}
.px-5 {
  padding-left: 20px;
  padding-right: 20px;
}
.px-6 {
  padding-left: 24px;
  padding-right: 24px;
}
.px-7 {
  padding-left: 28px;
  padding-right: 28px;
}
.px-8 {
  padding-left: 32px;
  padding-right: 32px;
}
.py-0 {
  padding-top: 0;
  padding-bottom: 0;
}
.py-0\\.5 {
  padding-top: 2px;
  padding-bottom: 2px;
}
.py-1 {
  padding-top: 4px;
  padding-bottom: 4px;
}
.py-1\\.5 {
  padding-top: 6px;
  padding-bottom: 6px;
}
.py-10 {
  padding-top: 40px;
  padding-bottom: 40px;
}
.py-2 {
  padding-top: 8px;
  padding-bottom: 8px;
}
.py-3 {
  padding-top: 12px;
  padding-bottom: 12px;
}
.py-4 {
  padding-top: 16px;
  padding-bottom: 16px;
}
.py-5 {
  padding-top: 20px;
  padding-bottom: 20px;
}
.py-6 {
  padding-top: 24px;
  padding-bottom: 24px;
}
.py-7 {
  padding-top: 28px;
  padding-bottom: 28px;
}
.py-\\[7px\\] {
  padding-top: 7px;
  padding-bottom: 7px;
}
.pb-0 {
  padding-bottom: 0;
}
.pb-1 {
  padding-bottom: 4px;
}
.pb-10 {
  padding-bottom: 40px;
}
.pb-15 {
  padding-bottom: 60px;
}
.pb-2 {
  padding-bottom: 8px;
}
.pb-20 {
  padding-bottom: 80px;
}
.pb-3 {
  padding-bottom: 12px;
}
.pb-4 {
  padding-bottom: 16px;
}
.pb-40 {
  padding-bottom: 160px;
}
.pb-5 {
  padding-bottom: 20px;
}
.pb-50 {
  padding-bottom: 200px;
}
.pb-6 {
  padding-bottom: 24px;
}
.pb-7 {
  padding-bottom: 28px;
}
.pl-0 {
  padding-left: 0;
}
.pl-1 {
  padding-left: 4px;
}
.pl-10 {
  padding-left: 40px;
}
.pl-11 {
  padding-left: 44px;
}
.pl-2 {
  padding-left: 8px;
}
.pl-3 {
  padding-left: 12px;
}
.pl-4 {
  padding-left: 16px;
}
.pl-5 {
  padding-left: 20px;
}
.pl-6 {
  padding-left: 24px;
}
.pl-7 {
  padding-left: 28px;
}
.pl-8 {
  padding-left: 32px;
}
.pl-\\[6px\\] {
  padding-left: 6px;
}
.pl-main-content {
  padding-left: 104px;
}
.pl-main-content--opened {
  padding-left: 300px;
}
.pr-0 {
  padding-right: 0;
}
.pr-0\\.5 {
  padding-right: 2px;
}
.pr-1 {
  padding-right: 4px;
}
.pr-10 {
  padding-right: 40px;
}
.pr-17 {
  padding-right: 68px;
}
.pr-2 {
  padding-right: 8px;
}
.pr-3 {
  padding-right: 12px;
}
.pr-4 {
  padding-right: 16px;
}
.pr-5 {
  padding-right: 20px;
}
.pr-6 {
  padding-right: 24px;
}
.pr-7 {
  padding-right: 28px;
}
.pr-8 {
  padding-right: 32px;
}
.pt-0 {
  padding-top: 0;
}
.pt-1 {
  padding-top: 4px;
}
.pt-10 {
  padding-top: 40px;
}
.pt-14 {
  padding-top: 56px;
}
.pt-2 {
  padding-top: 8px;
}
.pt-20 {
  padding-top: 80px;
}
.pt-3 {
  padding-top: 12px;
}
.pt-4 {
  padding-top: 16px;
}
.pt-48 {
  padding-top: 192px;
}
.pt-5 {
  padding-top: 20px;
}
.pt-6 {
  padding-top: 24px;
}
.pt-8 {
  padding-top: 32px;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.\\!text-13 {
  font-size: 13px !important;
}
.text-10 {
  font-size: 10px;
}
.text-11 {
  font-size: 11px;
}
.text-12 {
  font-size: 12px;
}
.text-13 {
  font-size: 13px;
}
.text-14 {
  font-size: 14px;
}
.text-15 {
  font-size: 15px;
}
.text-16 {
  font-size: 16px;
}
.text-18 {
  font-size: 18px;
}
.text-20 {
  font-size: 20px;
}
.text-22 {
  font-size: 22px;
}
.text-24 {
  font-size: 24px;
}
.text-30 {
  font-size: 30px;
}
.text-36 {
  font-size: 36px;
}
.text-3xl {
  font-size: 30px;
}
.text-4xl {
  font-size: 36px;
}
.text-9 {
  font-size: 9px;
}
.text-\\[11px\\] {
  font-size: 11px;
}
.text-\\[12px\\] {
  font-size: 12px;
}
.text-\\[13px\\] {
  font-size: 13px;
}
.text-\\[14px\\] {
  font-size: 14px;
}
.text-\\[30px\\] {
  font-size: 30px;
}
.text-base {
  font-size: 16px;
}
.text-sm {
  font-size: 14px;
}
.text-xl {
  font-size: 20px;
}
.text-xs {
  font-size: 12px;
}
.font-400 {
  font-weight: 400;
}
.font-500 {
  font-weight: 500;
}
.font-600 {
  font-weight: 600;
}
.font-700 {
  font-weight: 700;
}
.uppercase {
  text-transform: uppercase;
}
.lowercase {
  text-transform: lowercase;
}
.capitalize {
  text-transform: capitalize;
}
.italic {
  font-style: italic;
}
.ordinal {
  --tw-ordinal: ordinal;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.leading-14 {
  line-height: 14px;
}
.leading-16 {
  line-height: 16px;
}
.leading-24 {
  line-height: 24px;
}
.leading-none {
  line-height: 1;
}
.tracking-wide {
  letter-spacing: 0.025em;
}
.tracking-wider {
  letter-spacing: 0.05em;
}
.\\!text-\\[\\#655E8E\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(101 94 142 / var(--tw-text-opacity)) !important;
}
.text-\\[\\#655E8E\\] {
  --tw-text-opacity: 1;
  color: rgb(101 94 142 / var(--tw-text-opacity));
}
.text-\\[rgb\\(var\\(--color-menu-text\\)\\)\\] {
  color: rgb(var(--color-menu-text));
}
.text-alert {
  --tw-text-opacity: 1;
  color: rgb(var(--color-alert) / var(--tw-text-opacity));
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.text-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(66 153 225 / var(--tw-text-opacity));
}
.text-blue-700 {
  --tw-text-opacity: 1;
  color: rgb(43 108 176 / var(--tw-text-opacity));
}
.text-blue-800 {
  --tw-text-opacity: 1;
  color: rgb(44 82 130 / var(--tw-text-opacity));
}
.text-dark-text {
  --tw-text-opacity: 1;
  color: rgb(var(--color-dark-text) / var(--tw-text-opacity));
}
.text-gray-300 {
  --tw-text-opacity: 1;
  color: rgb(207 207 211 / var(--tw-text-opacity));
}
.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(178 177 185 / var(--tw-text-opacity));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(139 139 151 / var(--tw-text-opacity));
}
.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(112 111 126 / var(--tw-text-opacity));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(84 84 101 / var(--tw-text-opacity));
}
.text-gray-800 {
  --tw-text-opacity: 1;
  color: rgb(57 56 76 / var(--tw-text-opacity));
}
.text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(29 28 51 / var(--tw-text-opacity));
}
.text-green-500 {
  --tw-text-opacity: 1;
  color: rgb(72 187 120 / var(--tw-text-opacity));
}
.text-green-600 {
  --tw-text-opacity: 1;
  color: rgb(56 161 105 / var(--tw-text-opacity));
}
.text-green-700 {
  --tw-text-opacity: 1;
  color: rgb(47 133 90 / var(--tw-text-opacity));
}
.text-green-800 {
  --tw-text-opacity: 1;
  color: rgb(39 103 73 / var(--tw-text-opacity));
}
.text-green-900 {
  --tw-text-opacity: 1;
  color: rgb(34 84 61 / var(--tw-text-opacity));
}
.text-indigo-400 {
  --tw-text-opacity: 1;
  color: rgb(127 156 245 / var(--tw-text-opacity));
}
.text-indigo-500 {
  --tw-text-opacity: 1;
  color: rgb(102 126 234 / var(--tw-text-opacity));
}
.text-indigo-600 {
  --tw-text-opacity: 1;
  color: rgb(90 103 216 / var(--tw-text-opacity));
}
.text-indigo-700 {
  --tw-text-opacity: 1;
  color: rgb(76 81 191 / var(--tw-text-opacity));
}
.text-indigo-800 {
  --tw-text-opacity: 1;
  color: rgb(67 65 144 / var(--tw-text-opacity));
}
.text-indigo-900 {
  --tw-text-opacity: 1;
  color: rgb(60 54 107 / var(--tw-text-opacity));
}
.text-off-white {
  --tw-text-opacity: 1;
  color: rgb(var(--color-off-white) / var(--tw-text-opacity));
}
.text-on-primary {
  --tw-text-opacity: 1;
  color: rgb(var(--color-on-primary) / var(--tw-text-opacity));
}
.text-on-secondary {
  --tw-text-opacity: 1;
  color: rgb(var(--color-on-secondary) / var(--tw-text-opacity));
}
.text-on-tertiary {
  --tw-text-opacity: 1;
  color: rgb(var(--color-on-tertiary) / var(--tw-text-opacity));
}
.text-orange-900 {
  --tw-text-opacity: 1;
  color: rgb(123 52 30 / var(--tw-text-opacity));
}
.text-pink-500 {
  --tw-text-opacity: 1;
  color: rgb(237 100 166 / var(--tw-text-opacity));
}
.text-pink-700 {
  --tw-text-opacity: 1;
  color: rgb(184 50 128 / var(--tw-text-opacity));
}
.text-primary {
  --tw-text-opacity: 1;
  color: rgb(var(--color-primary) / var(--tw-text-opacity));
}
.text-purple-300 {
  --tw-text-opacity: 1;
  color: rgb(214 188 250 / var(--tw-text-opacity));
}
.text-purple-500 {
  --tw-text-opacity: 1;
  color: rgb(159 122 234 / var(--tw-text-opacity));
}
.text-purple-600 {
  --tw-text-opacity: 1;
  color: rgb(128 90 213 / var(--tw-text-opacity));
}
.text-purple-700 {
  --tw-text-opacity: 1;
  color: rgb(107 70 193 / var(--tw-text-opacity));
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(245 101 101 / var(--tw-text-opacity));
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(229 62 62 / var(--tw-text-opacity));
}
.text-red-700 {
  --tw-text-opacity: 1;
  color: rgb(197 48 48 / var(--tw-text-opacity));
}
.text-red-800 {
  --tw-text-opacity: 1;
  color: rgb(155 44 44 / var(--tw-text-opacity));
}
.text-red-900 {
  --tw-text-opacity: 1;
  color: rgb(116 42 42 / var(--tw-text-opacity));
}
.text-secondary {
  --tw-text-opacity: 1;
  color: rgb(var(--color-secondary) / var(--tw-text-opacity));
}
.text-semi-dark-text {
  --tw-text-opacity: 1;
  color: rgb(var(--color-semi-dark-text) / var(--tw-text-opacity));
}
.text-surface-light {
  --tw-text-opacity: 1;
  color: rgb(var(--color-surface-light) / var(--tw-text-opacity));
}
.text-tertiary {
  --tw-text-opacity: 1;
  color: rgb(var(--color-tertiary) / var(--tw-text-opacity));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.text-yellow-600 {
  --tw-text-opacity: 1;
  color: rgb(214 158 46 / var(--tw-text-opacity));
}
.text-opacity-50 {
  --tw-text-opacity: 0.5;
}
.text-opacity-80 {
  --tw-text-opacity: 0.8;
}
.underline {
  text-decoration-line: underline;
}
.line-through {
  text-decoration-line: line-through;
}
.no-underline {
  text-decoration-line: none;
}
.accent-primary {
  accent-color: rgb(var(--color-primary) / 1);
}
.accent-secondary {
  accent-color: rgb(var(--color-secondary) / 1);
}
.opacity-0 {
  opacity: 0;
}
.opacity-100 {
  opacity: 1;
}
.opacity-25 {
  opacity: 0.25;
}
.opacity-30 {
  opacity: 0.30;
}
.opacity-40 {
  opacity: 0.4;
}
.opacity-50 {
  opacity: 0.5;
}
.opacity-60 {
  opacity: 0.6;
}
.opacity-70 {
  opacity: 0.7;
}
.opacity-75 {
  opacity: 0.75;
}
.opacity-80 {
  opacity: 0.8;
}
.opacity-90 {
  opacity: 0.9;
}
.\\!shadow-mini-card {
  --tw-shadow: 0px 10px 40px rgba(35, 17, 131, 0.1) !important;
  --tw-shadow-colored: 0px 10px 40px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-2xl-eq {
  --tw-shadow: 0 0 50px -12px rgba(0, 0, 0, 0.25);
  --tw-shadow-colored: 0 0 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-card {
  --tw-shadow: 0px 0px 4px rgba(71, 41, 111, 0.16);
  --tw-shadow-colored: 0px 0px 4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-card-md {
  --tw-shadow: 0px 2px 4px rgba(35, 17, 131, 0.16);
  --tw-shadow-colored: 0px 2px 4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-input {
  --tw-shadow: 0px 2px 6px rgba(35, 17, 131, 0.08);
  --tw-shadow-colored: 0px 2px 6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg-eq {
  --tw-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  --tw-shadow-colored: 0 0 15px -3px var(--tw-shadow-color), 0 4px 6px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-mini-card {
  --tw-shadow: 0px 10px 40px rgba(35, 17, 131, 0.1);
  --tw-shadow-colored: 0px 10px 40px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-mini-card-alt {
  --tw-shadow: 0px 3px 15px rgba(35, 17, 131, 0.1);
  --tw-shadow-colored: 0px 3px 15px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-navigation {
  --tw-shadow: 0px 0px 20px rgba(var(--color-menu-shadow) / 0.4);
  --tw-shadow-colored: 0px 0px 20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 10px 10px -5px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xs {
  --tw-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);
  --tw-shadow-colored: 0 0 0 1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline {
  outline-style: solid;
}
.outline-0 {
  outline-width: 0px;
}
.outline-1 {
  outline-width: 1px;
}
.outline-2 {
  outline-width: 2px;
}
.outline-primary {
  outline-color: rgb(var(--color-primary) / 1);
}
.ring-2 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.grayscale {
  --tw-grayscale: grayscale(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur-sm {
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-filter {
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition {
  transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform, height;
}
.transition-all {
  transition-property: all;
}
.transition-colors {
  transition-property: background-color, border-color, color, fill, stroke;
}
.transition-opacity {
  transition-property: opacity;
}
.transition-transform {
  transition-property: transform;
}
.transition-width {
  transition-property: width;
}
.delay-500 {
  transition-delay: 500ms;
}
.duration-100 {
  transition-duration: 100ms;
}
.duration-150 {
  transition-duration: 150ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.duration-500 {
  transition-duration: 500ms;
}
.ease-in {
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}

/* Scrollbar styles */
/* width */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #d6d5d5;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #999;
}

.min-w-full-1 {
  min-width: calc(100% - 1px);
}
:root {
  --vvh: 100svh;
}
.h-screen {
  /*height: 100vh;*/
  /*height: var(--vvh);*/
  height: 100svh !important;
}

input {
  color: rgb(var(--color-input));
}

.first\\:border-t-0:first-child {
  border-top-width: 0px;
}

.focus-within\\:border-primary:focus-within {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));
}

.focus-within\\:border-white:focus-within {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}

.hover\\:cursor-grab:hover {
  cursor: grab;
}

.hover\\:border-purple-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(233 230 252 / var(--tw-border-opacity));
}

.hover\\:border-secondary\\/40:hover {
  border-color: rgb(var(--color-secondary) / 0.4);
}

.hover\\:\\!bg-alert\\/10:hover {
  background-color: rgb(var(--color-alert) / 0.1) !important;
}

.hover\\:bg-alert:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-alert) / var(--tw-bg-opacity));
}

.hover\\:bg-alert\\/10:hover {
  background-color: rgb(var(--color-alert) / 0.1);
}

.hover\\:bg-gray-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity));
}

.hover\\:bg-gray-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(235 235 236 / var(--tw-bg-opacity));
}

.hover\\:bg-gray-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(207 207 211 / var(--tw-bg-opacity));
}

.hover\\:bg-green-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(56 161 105 / var(--tw-bg-opacity));
}

.hover\\:bg-indigo-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(90 103 216 / var(--tw-bg-opacity));
}

.hover\\:bg-primary:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));
}

.hover\\:bg-primary-hover:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-primary-hover) / var(--tw-bg-opacity));
}

.hover\\:bg-red-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(229 62 62 / var(--tw-bg-opacity));
}

.hover\\:bg-secondary:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-secondary) / var(--tw-bg-opacity));
}

.hover\\:bg-secondary\\/20:hover {
  background-color: rgb(var(--color-secondary) / 0.2);
}

.hover\\:bg-semi-dark-text:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-semi-dark-text) / var(--tw-bg-opacity));
}

.hover\\:bg-tertiary:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-tertiary) / var(--tw-bg-opacity));
}

.hover\\:bg-opacity-10:hover {
  --tw-bg-opacity: 0.1;
}

.hover\\:bg-opacity-15:hover {
  --tw-bg-opacity: 0.15;
}

.hover\\:bg-opacity-\\[90\\%\\]:hover {
  --tw-bg-opacity: 90%;
}

.hover\\:\\!text-alert:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(var(--color-alert) / var(--tw-text-opacity)) !important;
}

.hover\\:text-alert:hover {
  --tw-text-opacity: 1;
  color: rgb(var(--color-alert) / var(--tw-text-opacity));
}

.hover\\:text-indigo-500:hover {
  --tw-text-opacity: 1;
  color: rgb(102 126 234 / var(--tw-text-opacity));
}

.hover\\:text-indigo-800:hover {
  --tw-text-opacity: 1;
  color: rgb(67 65 144 / var(--tw-text-opacity));
}

.hover\\:text-off-white:hover {
  --tw-text-opacity: 1;
  color: rgb(var(--color-off-white) / var(--tw-text-opacity));
}

.hover\\:text-on-primary-hover:hover {
  --tw-text-opacity: 1;
  color: rgb(var(--color-on-primary-hover) / var(--tw-text-opacity));
}

.hover\\:text-on-secondary:hover {
  --tw-text-opacity: 1;
  color: rgb(var(--color-on-secondary) / var(--tw-text-opacity));
}

.hover\\:text-primary:hover {
  --tw-text-opacity: 1;
  color: rgb(var(--color-primary) / var(--tw-text-opacity));
}

.hover\\:text-purple-800:hover {
  --tw-text-opacity: 1;
  color: rgb(85 60 154 / var(--tw-text-opacity));
}

.hover\\:text-purple-900:hover {
  --tw-text-opacity: 1;
  color: rgb(68 51 122 / var(--tw-text-opacity));
}

.hover\\:text-semi-dark-text:hover {
  --tw-text-opacity: 1;
  color: rgb(var(--color-semi-dark-text) / var(--tw-text-opacity));
}

.hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.hover\\:underline:hover {
  text-decoration-line: underline;
}

.hover\\:opacity-100:hover {
  opacity: 1;
}

.hover\\:opacity-90:hover {
  opacity: 0.9;
}

.focus\\:border-blue-300:focus {
  --tw-border-opacity: 1;
  border-color: rgb(144 205 244 / var(--tw-border-opacity));
}

.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:ring-1:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-secondary:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(var(--color-secondary) / var(--tw-ring-opacity));
}

@media not all and (min-width: 996px) {
  .max-lg\\:absolute {
    position: absolute;
  }
  .max-lg\\:-left-\\[230px\\] {
    left: -230px;
  }
  .max-lg\\:left-0 {
    left: 0;
  }
  .max-lg\\:z-0 {
    z-index: 0;
  }
  .max-lg\\:z-1 {
    z-index: 1;
  }
  .max-lg\\:hidden {
    display: none;
  }
  .max-lg\\:min-h-full {
    min-height: 100%;
  }
  .max-lg\\:flex-wrap {
    flex-wrap: wrap;
  }
  .max-lg\\:shadow-xl {
    --tw-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
    --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 10px 10px -5px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }
}

@media not all and (min-width: 768px) {
  .max-md\\:col-span-4 {
    grid-column: span 4 / span 4;
  }
  .max-md\\:mt-3 {
    margin-top: 12px;
  }
  .max-md\\:mt-5 {
    margin-top: 20px;
  }
  .max-md\\:w-full {
    width: 100%;
  }
  .max-md\\:max-w-full {
    max-width: 100%;
  }
  .max-md\\:flex-grow {
    flex-grow: 1;
  }
  .max-md\\:flex-row {
    flex-direction: row;
  }
  .max-md\\:flex-wrap {
    flex-wrap: wrap;
  }
  .max-md\\:px-3 {
    padding-left: 12px;
    padding-right: 12px;
  }
}

@media not all and (min-width: 576px) {
  .max-sm\\:mb-1 {
    margin-bottom: 4px;
  }
  .max-sm\\:ml-auto {
    margin-left: auto;
  }
  .max-sm\\:mr-0 {
    margin-right: 0;
  }
  .max-sm\\:mr-1 {
    margin-right: 4px;
  }
  .max-sm\\:mr-4 {
    margin-right: 16px;
  }
  .max-sm\\:block {
    display: block;
  }
  .max-sm\\:flex {
    display: flex;
  }
  .max-sm\\:hidden {
    display: none;
  }
  .max-sm\\:h-15 {
    height: 60px;
  }
  .max-sm\\:w-full {
    width: 100%;
  }
  .max-sm\\:translate-y-full {
    --tw-translate-y: 100%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
  .max-sm\\:flex-col {
    flex-direction: column;
  }
  .max-sm\\:flex-wrap {
    flex-wrap: wrap;
  }
  .max-sm\\:items-center {
    align-items: center;
  }
  .max-sm\\:gap-2 {
    gap: 8px;
  }
  .max-sm\\:pb-3 {
    padding-bottom: 12px;
  }
  .max-sm\\:pb-8 {
    padding-bottom: 32px;
  }
}

@media not all and (min-width: 400px) {
  .max-xs\\:flex-col {
    flex-direction: column;
  }
}

@media (min-width: 400px) {
  .xs\\:px-2 {
    padding-left: 8px;
    padding-right: 8px;
  }
}

@media (min-width: 576px) {
  .sm\\:col-span-2 {
    grid-column: span 2 / span 2;
  }
  .sm\\:mx-2 {
    margin-left: 8px;
    margin-right: 8px;
  }
  .sm\\:my-auto {
    margin-top: auto;
    margin-bottom: auto;
  }
  .sm\\:mb-0 {
    margin-bottom: 0;
  }
  .sm\\:mb-20 {
    margin-bottom: 80px;
  }
  .sm\\:mb-4 {
    margin-bottom: 16px;
  }
  .sm\\:ml-1 {
    margin-left: 4px;
  }
  .sm\\:ml-2 {
    margin-left: 8px;
  }
  .sm\\:ml-3 {
    margin-left: 12px;
  }
  .sm\\:mr-1 {
    margin-right: 4px;
  }
  .sm\\:mr-10 {
    margin-right: 40px;
  }
  .sm\\:mr-2 {
    margin-right: 8px;
  }
  .sm\\:mr-4 {
    margin-right: 16px;
  }
  .sm\\:mr-8 {
    margin-right: 32px;
  }
  .sm\\:mt-10 {
    margin-top: 40px;
  }
  .sm\\:mt-8 {
    margin-top: 32px;
  }
  .sm\\:flex {
    display: flex;
  }
  .sm\\:hidden {
    display: none;
  }
  .sm\\:h-10 {
    height: 40px;
  }
  .sm\\:h-9 {
    height: 36px;
  }
  .sm\\:h-auto {
    height: auto;
  }
  .sm\\:w-1\\/2 {
    width: 50%;
  }
  .sm\\:w-400 {
    width: 400px;
  }
  .sm\\:w-450 {
    width: 450px;
  }
  .sm\\:w-600 {
    width: 600px;
  }
  .sm\\:w-700 {
    width: 700px;
  }
  .sm\\:w-800 {
    width: 800px;
  }
  .sm\\:w-\\[120px\\] {
    width: 120px;
  }
  .sm\\:w-auto {
    width: auto;
  }
  .sm\\:w-screen90 {
    width: 90vw;
  }
  .sm\\:min-w-500 {
    min-width: 500px;
  }
  .sm\\:min-w-600 {
    min-width: 600px;
  }
  .sm\\:max-w-400 {
    max-width: 400px;
  }
  .sm\\:max-w-500 {
    max-width: 500px;
  }
  .sm\\:flex-shrink-0 {
    flex-shrink: 0;
  }
  .sm\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .sm\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .sm\\:grid-cols-collection {
    grid-template-columns: repeat(auto-fit, 325px);
  }
  .sm\\:flex-row {
    flex-direction: row;
  }
  .sm\\:flex-nowrap {
    flex-wrap: nowrap;
  }
  .sm\\:rounded-14 {
    border-radius: 14px;
  }
  .sm\\:rounded-20 {
    border-radius: 20px;
  }
  .sm\\:rounded-b-26 {
    border-bottom-right-radius: 26px;
    border-bottom-left-radius: 26px;
  }
  .sm\\:rounded-t-26 {
    border-top-left-radius: 26px;
    border-top-right-radius: 26px;
  }
  .sm\\:p-10 {
    padding: 40px;
  }
  .sm\\:p-3 {
    padding: 12px;
  }
  .sm\\:p-5 {
    padding: 20px;
  }
  .sm\\:px-2 {
    padding-left: 8px;
    padding-right: 8px;
  }
  .sm\\:px-4 {
    padding-left: 16px;
    padding-right: 16px;
  }
  .sm\\:py-3 {
    padding-top: 12px;
    padding-bottom: 12px;
  }
  .sm\\:pb-0 {
    padding-bottom: 0;
  }
  .sm\\:pl-6 {
    padding-left: 24px;
  }
  .sm\\:pr-10 {
    padding-right: 40px;
  }
  .sm\\:pr-2 {
    padding-right: 8px;
  }
  .sm\\:pr-5 {
    padding-right: 20px;
  }
  .sm\\:pr-6 {
    padding-right: 24px;
  }
  .sm\\:pt-10 {
    padding-top: 40px;
  }
  .sm\\:pt-4 {
    padding-top: 16px;
  }
  .sm\\:pt-8 {
    padding-top: 32px;
  }
  .sm\\:text-center {
    text-align: center;
  }
  .sm\\:text-24 {
    font-size: 24px;
  }
  .sm\\:text-3xl {
    font-size: 30px;
  }
  .sm\\:text-5xl {
    font-size: 48px;
  }
  .sm\\:shadow-2xl {
    --tw-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
    --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }
  .sm\\:shadow-xl {
    --tw-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
    --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 10px 10px -5px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }
  .sm\\:hover\\:bg-indigo-300:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(163 191 250 / var(--tw-bg-opacity));
  }
}

@media (min-width: 768px) {
  .md\\:-right-30 {
    right: -120px;
  }
  .md\\:mx-10 {
    margin-left: 40px;
    margin-right: 40px;
  }
  .md\\:mx-2 {
    margin-left: 8px;
    margin-right: 8px;
  }
  .md\\:my-0 {
    margin-top: 0;
    margin-bottom: 0;
  }
  .md\\:mb-10 {
    margin-bottom: 40px;
  }
  .md\\:ml-2 {
    margin-left: 8px;
  }
  .md\\:ml-5 {
    margin-left: 20px;
  }
  .md\\:mr-2 {
    margin-right: 8px;
  }
  .md\\:mr-8 {
    margin-right: 32px;
  }
  .md\\:mt-0 {
    margin-top: 0;
  }
  .md\\:mt-10 {
    margin-top: 40px;
  }
  .md\\:mt-2 {
    margin-top: 8px;
  }
  .md\\:hidden {
    display: none;
  }
  .md\\:h-\\[130px\\] {
    height: 130px;
  }
  .md\\:min-h-600 {
    min-height: 600px;
  }
  .md\\:w-1\\/2 {
    width: 50%;
  }
  .md\\:w-1\\/3 {
    width: 33.333333%;
  }
  .md\\:w-10 {
    width: 40px;
  }
  .md\\:w-15 {
    width: 60px;
  }
  .md\\:w-400 {
    width: 400px;
  }
  .md\\:w-600 {
    width: 600px;
  }
  .md\\:w-900 {
    width: 900px;
  }
  .md\\:w-\\[130px\\] {
    width: 130px;
  }
  .md\\:max-w-400 {
    max-width: 400px;
  }
  .md\\:max-w-500 {
    max-width: 500px;
  }
  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .md\\:flex-row {
    flex-direction: row;
  }
  .md\\:border-r {
    border-right-width: 1px;
  }
  .md\\:px-10 {
    padding-left: 40px;
    padding-right: 40px;
  }
  .md\\:pl-0 {
    padding-left: 0;
  }
  .md\\:pl-3 {
    padding-left: 12px;
  }
  .md\\:pr-10 {
    padding-right: 40px;
  }
  .md\\:pr-15 {
    padding-right: 60px;
  }
  .md\\:pt-0 {
    padding-top: 0;
  }
  .md\\:text-center {
    text-align: center;
  }
  .md\\:text-24 {
    font-size: 24px;
  }
  .md\\:text-36 {
    font-size: 36px;
  }
  .md\\:text-4xl {
    font-size: 36px;
  }
  .md\\:text-6xl {
    font-size: 64px;
  }
  .md\\:hover\\:text-primary:hover {
    --tw-text-opacity: 1;
    color: rgb(var(--color-primary) / var(--tw-text-opacity));
  }
}

@media (min-width: 996px) {
  .lg\\:left-top-bar {
    left: 104px;
  }
  .lg\\:left-top-bar--opened {
    left: 300px;
  }
  .lg\\:order-2 {
    order: 2;
  }
  .lg\\:col-span-2 {
    grid-column: span 2 / span 2;
  }
  .lg\\:-ml-4 {
    margin-left: -16px;
  }
  .lg\\:ml-2 {
    margin-left: 8px;
  }
  .lg\\:mr-2 {
    margin-right: 8px;
  }
  .lg\\:flex {
    display: flex;
  }
  .lg\\:hidden {
    display: none;
  }
  .lg\\:h-23 {
    height: 92px;
  }
  .lg\\:w-1\\/2 {
    width: 50%;
  }
  .lg\\:w-1\\/4 {
    width: 25%;
  }
  .lg\\:w-4\\/12 {
    width: 33.333333%;
  }
  .lg\\:w-5\\/12 {
    width: 41.666667%;
  }
  .lg\\:w-7\\/12 {
    width: 58.333333%;
  }
  .lg\\:w-8\\/12 {
    width: 66.666667%;
  }
  .lg\\:w-900 {
    width: 900px;
  }
  .lg\\:w-auto {
    width: auto;
  }
  .lg\\:w-sidebar {
    width: 104px;
  }
  .lg\\:w-sidebar--opened {
    width: 300px;
  }
  .lg\\:w-top-menu {
    width: calc(100% - 104px);
  }
  .lg\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .lg\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .lg\\:flex-col {
    flex-direction: column;
  }
  .lg\\:flex-nowrap {
    flex-wrap: nowrap;
  }
  .lg\\:p-8 {
    padding: 32px;
  }
  .lg\\:px-10 {
    padding-left: 40px;
    padding-right: 40px;
  }
  .lg\\:px-5 {
    padding-left: 20px;
    padding-right: 20px;
  }
  .lg\\:py-7 {
    padding-top: 28px;
    padding-bottom: 28px;
  }
  .lg\\:pb-0 {
    padding-bottom: 0;
  }
  .lg\\:pl-10 {
    padding-left: 40px;
  }
  .lg\\:pl-2 {
    padding-left: 8px;
  }
  .lg\\:pl-7 {
    padding-left: 28px;
  }
  .lg\\:pl-main-content {
    padding-left: 104px;
  }
  .lg\\:pl-main-content--opened {
    padding-left: 300px;
  }
  .lg\\:pr-5 {
    padding-right: 20px;
  }
  .lg\\:pt-0 {
    padding-top: 0;
  }
  .lg\\:pt-14 {
    padding-top: 56px;
  }
  .lg\\:pt-18 {
    padding-top: 72px;
  }
  .lg\\:pt-4 {
    padding-top: 16px;
  }
  .lg\\:text-20 {
    font-size: 20px;
  }
}

@media (min-width: 1200px) {
  .xl\\:flex {
    display: flex;
  }
  .xl\\:w-1\\/3 {
    width: 33.333333%;
  }
  .xl\\:w-1\\/5 {
    width: 20%;
  }
  .xl\\:max-w-1\\/3 {
    max-width: 33.333333%;
  }
  .xl\\:max-w-2\\/3 {
    max-width: 66.666667%;
  }
  .xl\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .xl\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .xl\\:px-10 {
    padding-left: 40px;
    padding-right: 40px;
  }
}

@media (min-width: 1600px) {
  .xxl\\:w-1\\/4 {
    width: 25%;
  }
  .xxl\\:max-w-1\\/2 {
    max-width: 50%;
  }
  .xxl\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
